import { createSelector } from "reselect"
import { getDatesAdjusted as getDatesAdjustedHelper } from "helpers/dates"
import { getPeriod } from "modules/portfolio-root/selectors/portfolios"
import { getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getStartDate, getEndDate } from "selectors/dates"
import { getIsLoading } from "./data"

export const getDatesAdjusted = createSelector(
  [getPeriod, getStartDate, getEndDate, getLatestDate, getIsLoading],
  (period, startDate, endDate, latestDate, isLoading) => getDatesAdjustedHelper(period, startDate, endDate, latestDate) && !isLoading,
)
